import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1267d9aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CmsInvoicesContainer" }
const _hoisted_2 = { class: "CmsInvoicesContainer__container" }
const _hoisted_3 = { class: "relative flex items-center justify-end mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "CmsInvoicesContainer__columns"
}
const _hoisted_5 = { class: "flex items-center justify-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filters = _resolveComponent("filters")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_columns_icon = _resolveComponent("columns-icon")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_invoices = _resolveComponent("invoices", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_filters, {
      loading: _ctx.state.is_loading,
      onSubmit: _ctx.onApplyFilters,
      onReset: _ctx.onResetFilters
    }, null, 8, ["loading", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_button_dropdown, { icon: "fas fa-download" }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, {
              class: "small primary text",
              loading: _ctx.state.is_excel_loading,
              disabled: _ctx.state.is_excel_loading,
              onClick: _ctx.downloadReport
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Накладные на сегодня ")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_new_button, {
          class: "NewButton--outline NewButton--30 ml-3",
          onClick: _ctx.toggle
        }, {
          default: _withCtx(() => [
            _createVNode(_component_columns_icon, { class: "CmsInvoicesContainer__icon" }),
            _createTextVNode(" Колонки ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.state.is_open)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.columns, (column, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `column-${idx}`,
                  class: "CmsInvoicesContainer__columns-item"
                }, [
                  _createVNode(_component_new_checkbox, {
                    class: "checkbox--blue checkbox--light",
                    value: _ctx.state.columns[idx].isChecked,
                    "onUpdate:value": ($event: any) => ((_ctx.state.columns[idx].isChecked) = $event),
                    label: column.name
                  }, null, 8, ["value", "onUpdate:value", "label"])
                ]))
              }), 128)),
              _createVNode(_component_new_checkbox, {
                class: "border-t mt-5 pt-3 checkbox--blue checkbox--light CmsInvoicesContainer__columns-item",
                value: _ctx.isAllColumnsChecked,
                label: "Все колонки",
                "onUpdate:value": _ctx.onAllColumnsSelect
              }, null, 8, ["value", "onUpdate:value"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_new_button, {
                  loading: _ctx.state.is_excel_loading,
                  disabled: _ctx.state.is_excel_loading,
                  class: "NewButton--medium NewButton--square",
                  hint: "Скачать Excel",
                  onClick: _ctx.onSetColumns
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Подтвердить ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_invoices, {
        loading: _ctx.state.is_loading,
        failed: _ctx.state.is_failed,
        items: _ctx.state.items,
        columns: _ctx.filteredColumns,
        onRefresh: _ctx.loadInvoices
      }, null, 8, ["loading", "failed", "items", "columns", "onRefresh"])
    ])
  ]))
}